import { Component, OnInit } from '@angular/core';
import { Route, ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  plan_id  : any ;
  planDetails : any;

  constructor(private route: ActivatedRoute,private userService : UserService) { }

  ngOnInit() {
    this.getPlanIdFromURL();
  }

  getPlanDetalisServer(planId){
    let body = {"planId" : planId};
    this.userService.getPlanDetails(body).subscribe((resp : any) => {
      this.onPlansFetchedSucess(resp);
      }, (err) => {
    // Unable to log in
        this.onPlansFetchError(err);    
    });
  }


  onPlansFetchedSucess(resp){
     // console.log("Plan Detais"+JSON.stringify(resp));
      this.planDetails = resp;
      console.log(this.planDetails.price.$numberDouble);
  }

  onPlansFetchError(error){
    console.log("Plan Error"+JSON.stringify(error));
  }



  getPlanIdFromURL(){
    this.route.params.subscribe( params => {
      
      this.plan_id = params.plan_id;
      
      this.getPlanDetalisServer(this.plan_id);
    });
  }


}
